import { useNavigate, useParams } from "react-router-dom";
import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
import { scrollToTop } from "../../../utils/Functions";

const TestButton = ({
  title,
  step,
  isSmall,
  isReverse,
  isNull,
  isInline,
}: any) => {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <button
      className={`${
        isInline ? "" : "flex-1"
      } btn bg-pr_primary hover:bg-pr_blue_dark flex ${isSmall ? "py-2" : ""} ${
        isReverse ? "flex-row-reverse" : "flex-row"
      }`}
      onClick={() => {
        scrollToTop();
        navigate(isNull ? "/" : `/test-result/${id}?step=${Number(step)}`);
      }}
    >
      <h5 className="mt-[6px] ml-2 text-white font-rokh font-[800]">{title}</h5>
      <HiOutlineArrowNarrowLeft
        size={22}
        color="#fff"
        className={`${isReverse ? "rotate-180" : "rotate-0"}`}
      />
    </button>
  );
};

export default TestButton;
